import { loadStripe, type Stripe } from '@stripe/stripe-js';

let stripe: Promise<Stripe | null> | undefined;

export default function loadStripeOnce(
	...parameters: Parameters<typeof loadStripe>
): ReturnType<typeof loadStripe> {
	if (!stripe) {
		stripe = loadStripe(...parameters);
	}
	return stripe;
}
